import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolicyDataComponent } from './policy-data/policy-data.component';
import { RouterModule } from '@angular/router';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatFormFieldModule} from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';



const routes = [
  { 
    path: '',  component: PolicyDataComponent
  }
];


@NgModule({
  declarations: [
    PolicyDataComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatButtonToggleModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule
    
  ]
})
export class PolicySettingsModule { }
